<div class="flex flex-row gap-4">
    @for (licenceChecked of licensesChecked(); track licenceChecked.application) {
        <div
            class="flex flex-row items-center"
            [class.opacity-50]="!licenceChecked.isAvailable"
            [class.pointer-events-none]="!licenceChecked.isAvailable">
            <app-checkbox
                [checkboxState]="licenceChecked.isChecked ? CheckboxState.CHECKED : CheckboxState.UNCHECKED"
                [disabled]="!organizationAccessPermissionsService.canManageUser()"
                [matTooltip]="
                    (!organizationAccessPermissionsService.canManageUser() ? 'insufficientPermissions' : '') | transloco
                "
                (click)="changeSelection(licenceChecked.application)" />

            <app-logo
                class="cursor-pointer"
                logoClasses="w-7 px-1"
                [application]="licenceChecked.application"
                [matTooltip]="licenceChecked.application"
                (click)="changeSelection(licenceChecked.application)" />
        </div>
    }
</div>
